var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 8.7998H5.6C4.7176 8.7998 4 9.5174 4 10.3998V18.3998C4 19.2822 4.7176 19.9998 5.6 19.9998H13.6C14.4824 19.9998 15.2 19.2822 15.2 18.3998V10.3998C15.2 9.5174 14.4824 8.7998 13.6 8.7998Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3998 4H10.3998C9.97546 4 9.56849 4.16857 9.26843 4.46863C8.96838 4.76869 8.7998 5.17565 8.7998 5.6V7.2H15.1998C15.6242 7.2 16.0311 7.36857 16.3312 7.66863C16.6312 7.96869 16.7998 8.37565 16.7998 8.8V15.2H18.3998C18.8242 15.2 19.2311 15.0314 19.5312 14.7314C19.8312 14.4313 19.9998 14.0243 19.9998 13.6V5.6C19.9998 5.17565 19.8312 4.76869 19.5312 4.46863C19.2311 4.16857 18.8242 4 18.3998 4Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardImg2);
export default __webpack_public_path__ + "static/media/dashboard_img2.cd156ae64cd1f44fdee1026f1ca1787d.svg";
export { ForwardRef as ReactComponent };